import React, { useState } from 'react';
/*import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';*/

const CalendarCustom = () => {
    const [date, setDate] = useState(new Date());
    const [selectedRange, setSelectedRange] = useState({ start: null, end: null });

    const daysOfWeek = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
    const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];

    const renderHeader = () => {
        return (
            <div className="calendar-header">
                <div className="arrow" onClick={previousMonth} style={{ cursor: "pointer" }} >
                    {/*<FontAwesomeIcon icon={faArrowLeft} className='arrow-calendar-custom' />*/}
                    <i className='fa fa-chevron-left arrow-calendar-custom'  ></i>
                </div>
                <div className="select-container">
                    <select
                        style={{ color: "#051B44", fontWeight: "600", fontSize: "16px" }}
                        className='select-calendar-customm' onChange={changeMonth} value={date.getMonth()}>
                        {months.map((month, index) => (
                            <option key={index} value={index}>{month}</option>
                        ))}
                    </select>
                </div>
                <div className="select-container">
                    <select
                        style={{ color: "#1C5E91", fontWeight: "600", fontSize: "16px" }}
                        className='select-calendar-customm' onChange={changeYear} value={date.getFullYear()}>
                        {renderYearOptions()}
                    </select>
                </div>
                <div className="arrow" onClick={nextMonth} style={{ cursor: "pointer" }} >
                    {/*<FontAwesomeIcon icon={faArrowRight} className='arrow-calendar-custom' />*/}
                    <i className='fa fa-chevron-right arrow-calendar-custom'  ></i>
                </div>
            </div>
        );
    };

    const renderYearOptions = () => {
        let options = [];
        const currentYear = new Date().getFullYear();
        const startYear = currentYear - 10;
        const endYear = currentYear + 10;

        for (let year = startYear; year <= endYear; year++) {
            options.push(<option key={year} value={year}>{year}</option>);
        }

        return options;
    };

    const changeYear = (e) => {
        const newDate = new Date(date);
        newDate.setFullYear(parseInt(e.target.value));
        setDate(newDate);
    };

    const changeMonth = (e) => {
        const newDate = new Date(date);
        newDate.setMonth(parseInt(e.target.value));
        setDate(newDate);
    };

    const previousMonth = () => {
        const newDate = new Date(date);
        newDate.setMonth(newDate.getMonth() - 1);
        setDate(newDate);
    };

    const nextMonth = () => {
        const newDate = new Date(date);
        newDate.setMonth(newDate.getMonth() + 1);
        setDate(newDate);
    };

    const handleDayClick = (day) => {
        if (!selectedRange.start) {
            setSelectedRange({ start: day, end: null });
        } else if (!selectedRange.end && day > selectedRange.start) {
            setSelectedRange({ start: selectedRange.start, end: day });
        } else {
            setSelectedRange({ start: day, end: null });
        }
    };

    const renderDaysOfWeek = () => {
        return (
            <div className="days-of-week">
                {daysOfWeek.map((day, index) => (
                    <div key={index} className="day-calendar-customm">{day}</div>
                ))}
            </div>
        );
    };

    const renderCells = () => {
        const today = new Date();
        const currentMonth = date.getMonth();
        const currentYear = date.getFullYear();

        const firstDayOfMonth = new Date(currentYear, currentMonth, 1);
        const lastDayOfMonth = new Date(currentYear, currentMonth + 1, 0);
        const daysInMonth = lastDayOfMonth.getDate();
        const startingDay = firstDayOfMonth.getDay();

        let cells = [];
        let day = 1;

        // أيام الشهر السابق
        for (let i = startingDay; i > 0; i--) {
            const prevMonthDay = new Date(currentYear, currentMonth, 0 - i + 1).getDate();
            cells.push(
                <div key={`prev${i}`} className="cell-calendar-customm previous-month">
                    {prevMonthDay}
                </div>
            );
        }

        // أيام الشهر الحالي
        for (let i = 1; i <= daysInMonth; i++) {
            const className = `cell-calendar-customm ${isInRange(i) ? 'in-range' : ''} ${isSelected(i) ? 'selected' : ''} ${currentYear === today.getFullYear() && currentMonth === today.getMonth() && i === today.getDate() ? 'current-day' : ''}`;
            cells.push(
                <div
                    key={`current${i}`}
                    className={className}
                    onClick={() => handleDayClick(i)}
                >
                    {i}
                </div>
            );
            day++;
        }

        // أيام الشهر التالي
        const remainingCells = 6 * 7 - cells.length;
        for (let i = 1; i <= remainingCells; i++) {
            const nextMonthDay = new Date(currentYear, currentMonth + 1, i).getDate();
            cells.push(
                <div key={`next${i}`} className="cell-calendar-customm next-month">
                    {nextMonthDay}
                </div>
            );
        }

        return (
            <div className="calendar-grid">
                {cells}
            </div>
        );
    };

    const isInRange = (day) => {
        if (!selectedRange.start || !selectedRange.end) return false;
        return day > selectedRange.start && day < selectedRange.end;
    };

    const isSelected = (day) => {
        return day === selectedRange.start || day === selectedRange.end;
    };

    return (
        <div className="calendar-customm">
            {renderHeader()}
            {renderDaysOfWeek()}
            {renderCells()}
        </div>
    );
}

export default CalendarCustom